import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { PLATFORM_DISPLAY_NAMES } from 'constants/platforms-display-props';

export const defaultTranslationKeyOptions = {
    gameName: 'gameName',
    GameName: 'GameName',
    PhaseName: 'PhaseName'
};

export enum MODIFIED_TRANSLATION_KEYS_OPTION_NAMES {
    PLATFORM = 'platform'
}

export const MODIFIED_TRANSLATION_KEYS_OPTIONS: { [key in string]: { [key2 in string]: string }} = {
    [MODIFIED_TRANSLATION_KEYS_OPTION_NAMES.PLATFORM]: {
        [PLATFORM_TYPES.PC]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.PC],
        [PLATFORM_TYPES.XONE]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.XONE],
        [PLATFORM_TYPES.PS4]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.PS4],
        [PLATFORM_TYPES.SWITCH]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.SWITCH],
        [PLATFORM_TYPES.WEB]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.WEB],
        [PLATFORM_TYPES.MOBILE]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.MOBILE],
        [PLATFORM_TYPES.IOS]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.IOS],
        [PLATFORM_TYPES.ANDROID]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.ANDROID],
        [PLATFORM_TYPES.OCULUSVR]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.OCULUSVR],
        [PLATFORM_TYPES.STEAMVR]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.STEAMVR],
        [PLATFORM_TYPES.STEAM]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.STEAM],
        [PLATFORM_TYPES.STADIA]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.STADIA],
        [PLATFORM_TYPES.EPIC]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.EPIC],
        [PLATFORM_TYPES.XSX]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.XSX],
        [PLATFORM_TYPES.PS5]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.PS5],
        [PLATFORM_TYPES.LUNA]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.LUNA],
        [PLATFORM_TYPES.AMAZON]: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.AMAZON],
    }
};
